import { render, staticRenderFns } from "./configuracao-usuarios.vue?vue&type=template&id=1611132e&scoped=true"
import script from "./configuracao-usuarios.vue?vue&type=script&lang=ts"
export * from "./configuracao-usuarios.vue?vue&type=script&lang=ts"
import style0 from "./configuracao-usuarios.vue?vue&type=style&index=0&id=1611132e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1611132e",
  null
  
)

export default component.exports